import { style } from 'styled-system';
var transformValueFromTheme = function (n, theme) {
    var val = theme[n] || n;
    return typeof val !== 'string' ? val + 'px' : val;
};
// Default width/height/top etc. helpers from styled-system are not
// using theme values, this is why we are creating our own.
//
// More info:
//   https://styled-system.com/#width
//   https://styled-system.com/api#customize
export var themeWidth = style({
    prop: 'themeWidth',
    cssProperty: 'width',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMaxWidth = style({
    prop: 'themeMaxWidth',
    cssProperty: 'maxWidth',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMinWidth = style({
    prop: 'themeMinWidth',
    cssProperty: 'minWidth',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeHeight = style({
    prop: 'themeHeight',
    cssProperty: 'height',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMaxHeight = style({
    prop: 'themeMaxHeight',
    cssProperty: 'maxHeight',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMinHeight = style({
    prop: 'themeMinHeight',
    cssProperty: 'minHeight',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeTop = style({
    prop: 'themeTop',
    cssProperty: 'top',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeRight = style({
    prop: 'themeRight',
    cssProperty: 'right',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeBottom = style({
    prop: 'themeBottom',
    cssProperty: 'bottom',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeLeft = style({
    prop: 'themeLeft',
    cssProperty: 'left',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var columns = style({
    prop: 'columns',
    cssProperty: 'columns',
});
export var boxSizing = style({
    prop: 'boxSizing',
});
export var flexGrow = style({
    prop: 'flexGrow',
});
export var textDecoration = style({
    prop: 'textDecoration',
});
export var overflowY = style({
    prop: 'overflowY',
});
export var overflowX = style({
    prop: 'overflowX',
});
export var fill = style({
    prop: 'fill',
    key: 'colors',
});
export var stroke = style({
    prop: 'stroke',
    key: 'colors',
});
